window.codeConfig = {
	// 状态码
	success:200,
	error:500,
	commonError:509,
}
